import { gql } from '@apollo/client';

export const ESTATE_QUERY = gql`
  query Estate($input: EstateInput!, $isObjectPage: Boolean!) {
    estate(input: $input) {
      estateId
      isProjectMaster
      assignmentType
      assignmentTypeMapped
      streetAddress
      title
      eiendomsprofil {
        meta {
          order {
            status
          }
        }
      }
      images(finn: $isObjectPage) {
        floorplans {
          imageId
        }
        list {
          imageId
        }
        main {
          url
        }
      }
    }
  }
`;

export const ESTATE_IS_PROJECT_QUERY = gql`
  query EstateIsProject($input: EstateInput!) {
    estate(input: $input) {
      estateId
      isProjectMaster
    }
  }
`;

export const ESTATE_ASSIGNMENT_TYPE_QUERY = gql`
  query EstateAssignmentType($input: EstateInput!) {
    estate(input: $input) {
      estateId
      assignmentType
      assignmentTypeMapped
    }
  }
`;
